import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import React from 'react';

import { Text } from '../../common';
import { AddNewFieldBtnWrapS } from '../companyEditS';

const AddNewFieldBtn = ({ push }) => (
  <AddNewFieldBtnWrapS onClick={() => push('')} >
    <Text color='red' style={{ fontSize: '18px', margin: 5 }}>
      <FontAwesomeIcon  icon='plus-circle'/>
    </Text>
    <Text size='smallText'>
      { t('companyEdit.addItemBtn') }
    </Text>
  </AddNewFieldBtnWrapS>
);

export default AddNewFieldBtn
